import { Box, Typography } from '@mui/material';

import { observer } from 'mobx-react-lite';

import moment from 'moment';
import { FC } from 'react';
import useReservations from '../../hooks/useReservations';

import phone from '../../assets/phone.png';
import CenterBox from '../../components/container/CenterBox';
import DashbboardContainer from '../../components/container/DashbboardContainer';

interface Props {
  customerId: number;
}

const DashReservations: FC<Props> = observer(props => {
  const { customerId } = props;

  const { reservations } = useReservations(customerId);

  if (!customerId) {
    return <div>Keine Kundennummer vorhanden</div>;
  }

  const firstThreeReservations = reservations?.slice(0, 3);

  return (
    <DashbboardContainer
      label="Buchungen"
      btnLabel="Buchungen Verwalten"
      linkTo="/reservierungen"
    >
      <Box
        width={1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyItems: 'center',
        }}
      >
        <Box
          width={1}
          bgcolor="secondary.light"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CenterBox sxProps={{ width: '30%' }}>
            <img src={phone} alt="phone" width="80%" />
          </CenterBox>

          <Box width={1}>
            {firstThreeReservations?.length === 0 && (
              <Typography variant="body1" color="secondary.main">
                {'Derzeit keine Buchungen'.toUpperCase()}
              </Typography>
            )}
            {firstThreeReservations?.map(reservation => (
              <CenterBox
                key={reservation.reservierungs_id}
                sxProps={{
                  width: '100%',
                  backgroundColor: 'background.paper',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Typography variant="body1" color="secondary.main" m={1}>
                    {reservation.text}
                  </Typography>
                  <Typography variant="body1" color="secondary.main" m={1}>
                    {moment(reservation.beginn || '').format('DD.MM.YYYY')}
                  </Typography>
                </Box>
              </CenterBox>
            ))}
          </Box>
        </Box>
      </Box>
    </DashbboardContainer>
  );
});

export default DashReservations;
